import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/tada.gif';
import _imports_1 from '../assets/icon-document.svg';
import _imports_2 from '../assets/icon-calendar.svg';
import _imports_3 from '../assets/icon-chat.svg';
const _hoisted_1 = { class: "success-page" };
const _hoisted_2 = { class: "hero-container" };
const _hoisted_3 = {
    key: 0,
    class: "policy-card-container"
};
const _hoisted_4 = { class: "features-container" };
const _hoisted_5 = {
    key: 0,
    class: "feature-item"
};
const _hoisted_6 = {
    key: 0,
    class: "feature-item"
};
const _hoisted_7 = {
    key: 0,
    class: "feature-item"
};
const _hoisted_8 = { class: "anchor-bottom-no-nav" };
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useInsurance } from '@/composables/useInsurance';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import AccountListItem from './elements/AccountListItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InsuranceSuccessPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        useAuth();
        const { getPolicy } = useInsurance();
        const animateEmoji = ref(false);
        const showPolicy = ref(false);
        const showFeature1 = ref(false);
        const showFeature2 = ref(false);
        const showFeature3 = ref(false);
        const policy = ref(null);
        const policyId = computed(() => route.query.policyId);
        const allAnimationsComplete = computed(() => showFeature3.value);
        function formatDate(dateString) {
            if (!dateString)
                return '';
            const date = new Date(dateString);
            const options = { day: 'numeric', month: 'long', year: 'numeric' };
            return date.toLocaleDateString('en-GB', options);
        }
        function handleNext() {
            router.push({ path: '/insurancemoredetails', query: { policyId: policyId.value } });
        }
        function startAnimations() {
            setTimeout(() => {
                animateEmoji.value = true;
            }, 100);
            setTimeout(() => {
                showPolicy.value = true;
            }, 2000);
            setTimeout(() => {
                showFeature1.value = true;
            }, 2800);
            setTimeout(() => {
                showFeature2.value = true;
            }, 3400);
            setTimeout(() => {
                showFeature3.value = true;
            }, 4000);
        }
        onMounted(() => {
            if (policyId.value) {
                getPolicy(policyId.value, (result) => {
                    policy.value = result;
                    startAnimations();
                });
            }
            else {
                policy.value = {
                    provider: { name: 'AVIVA', logoUri: null },
                    policyType: { name: 'Buildings and contents' },
                    policyNumber: '',
                    endDate: '2026-07-09'
                };
                startAnimations();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "title" }, "Policy added successfully", -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["emoji-container", { 'animate': animateEmoji.value, 'fade-out': showPolicy.value }])
                        }, _cache[0] || (_cache[0] = [
                            _createElementVNode("img", {
                                src: _imports_0,
                                alt: "Celebration",
                                class: "party-emoji"
                            }, null, -1)
                        ]), 2),
                        _createVNode(_Transition, { name: "fade-slide" }, {
                            default: _withCtx(() => [
                                (showPolicy.value && policy.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(AccountListItem, {
                                            "provider-name": policy.value.provider?.name || 'Provider',
                                            line1: policy.value.policyType?.name || 'Insurance',
                                            line2: policy.value.policyNumber || '',
                                            value: formatDate(policy.value.endDate),
                                            label: "Renewal",
                                            "avatar-url": policy.value.provider?.logoUri || require('@/assets/round1.png')
                                        }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_Transition, { name: "fade-slide" }, {
                            default: _withCtx(() => [
                                (showFeature1.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
                                        _createElementVNode("img", {
                                            src: _imports_1,
                                            alt: "Documents",
                                            class: "feature-icon-img"
                                        }, null, -1),
                                        _createElementVNode("div", { class: "feature-text" }, [
                                            _createTextVNode(" Keep your documents safe,"),
                                            _createElementVNode("br"),
                                            _createTextVNode("all in one place ")
                                        ], -1)
                                    ])))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        _createVNode(_Transition, { name: "fade-slide" }, {
                            default: _withCtx(() => [
                                (showFeature2.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[2] || (_cache[2] = [
                                        _createElementVNode("img", {
                                            src: _imports_2,
                                            alt: "Reminders",
                                            class: "feature-icon-img"
                                        }, null, -1),
                                        _createElementVNode("div", { class: "feature-text" }, [
                                            _createTextVNode(" Get reminders before your"),
                                            _createElementVNode("br"),
                                            _createTextVNode("policy is due to renew ")
                                        ], -1)
                                    ])))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        _createVNode(_Transition, { name: "fade-slide" }, {
                            default: _withCtx(() => [
                                (showFeature3.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[3] || (_cache[3] = [
                                        _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: "Chat",
                                            class: "feature-icon-img"
                                        }, null, -1),
                                        _createElementVNode("div", { class: "feature-text" }, [
                                            _createTextVNode(" Chat with our assistant to"),
                                            _createElementVNode("br"),
                                            _createTextVNode("understand your policy ")
                                        ], -1)
                                    ])))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(MGButton, {
                            text: "Next",
                            arrow: true,
                            fullWidth: true,
                            disabled: !allAnimationsComplete.value,
                            onClick: handleNext
                        }, null, 8, ["disabled"])
                    ])
                ])
            ], 64));
        };
    }
});
